import {createRouter, createWebHistory} from 'vue-router';

import HomeComponent from '@/components/views/HomeComponent.vue';
import LoginComponent from '@/components/views/auth/LoginComponent.vue';
import RegisterComponent from "@/components/views/auth/RegisterComponent.vue";
import LinksComponent from "@/components/views/links/LinksComponent.vue";
import LinkUpdatedComponent from "@/components/views/links/LinkUpdatedComponent.vue";
import CreateShortLinkComponent from "@/components/views/links/CreateShortLinkComponent.vue";
import ShortRedirect from "@/components/views/redirect/ShortRedirect.vue";
import Error404Component from "@/components/views/Error404Component.vue";
import StatisticsAdminComponent from "@/components/views/stastistics/adminStatistics/StatisticsAdminComponent.vue";
import UserStatisticsComponent from "@/components/views/stastistics/userStatistics/UserStatisticsComponent.vue";
import UserComponent from "@/components/views/user/UserComponent.vue";

/**
 * Defines the application's route configuration.
 * Each route maps a URL path to a specific component and includes meta information for dynamic page titles and descriptions.
 *
 * @type {Array<Object>}
 * @property {string} path The URL path associated with the route.
 * @property {string} name The unique name identifying the route.
 * @property {Object} component The component rendered for the route.
 * @property {Object} meta Additional metadata associated with the route.
 * @property {string} meta.title The dynamic title for the page.
 * @property {string} meta.description The dynamic description for the page.
 */
const routes = [

    // Home page
    {path: '/', name: 'Home', component: HomeComponent, meta: { title: 'LinkCurt | Acortador de URLs gratuito', description: 'Acorta tus enlaces de forma rápida y gratuita. Gestiona y analiza tus URLs con nuestra herramienta de código abierto.' }},

    // Login page for existing users
    {path: '/login', name: 'Login', component: LoginComponent, meta: { title: 'Iniciar Sesión | LinkCurt', description: 'Accede a tu cuenta de LinkCurt para gestionar tus enlaces acortados y ver estadísticas.' }},

    // Register a new user
    {path: '/register', name: 'Register', component: RegisterComponent, meta: { title: 'Registro | LinkCurt', description: 'Crea una cuenta en LinkCurt para empezar a acortar y gestionar tus URLs de forma gratuita.' }},

    // User profile page
    {path: '/user', name: 'user', component: UserComponent, meta: { title: 'Mi Perfil | LinkCurt', description: 'Gestiona la información de tu perfil y la configuración de tu cuenta en LinkCurt.' }},

    // Links created by the user
    {path: '/links', name: 'Links', component: LinksComponent, meta: { title: 'Mis Enlaces | LinkCurt', description: 'Visualiza y administra todos los enlaces que has acortado con tu cuenta de LinkCurt.' }},

    //All links created
    {path: '/adminlinks', name: 'adminlinks', component: LinksComponent, meta: { title: 'Enlaces de Administrador | LinkCurt', description: 'Panel de administrador para gestionar todos los enlaces creados en la plataforma.' }},

    // Edit link to update it
    {path: '/link', name: 'Link', component: LinkUpdatedComponent, meta: { title: 'Editar Enlace | LinkCurt', description: 'Modifica la URL de destino o las propiedades de tu enlace acortado.' }},

    // Create a new short link
    {path: '/create-link', name: 'create link', component: CreateShortLinkComponent, meta: { title: 'Crear Enlace | LinkCurt', description: 'Crea un nuevo enlace corto personalizado de forma rápida y sencilla.' }},

    // Admin statistics
    {path: '/adminStatistics', name: 'adminStatistics', component: StatisticsAdminComponent, meta: { title: 'Estadísticas de Administrador | LinkCurt', description: 'Accede a las estadísticas globales de uso de la plataforma LinkCurt.' }},

    // User statistics
    {path: '/statistics', name: 'statistics', component: UserStatisticsComponent, meta: { title: 'Mis Estadísticas | LinkCurt', description: 'Analiza el rendimiento de tus enlaces con estadísticas detalladas de clics.' }},

    // Redirect to the original link
    {path: '/:shortLink(\\w{4})', name: 'ShortRedirect', component: ShortRedirect, meta: { title: 'Redirigiendo... | LinkCurt', description: 'Estás siendo redirigido a tu destino final a través de LinkCurt.' }},

    // Page not found
    {path: '/:pathMatch(.*)*', name: 'Error404', component: Error404Component, meta: { title: '404 No Encontrado | LinkCurt', description: 'La página que buscas no existe o ha sido movida.' }},


];

/**
 * Router instance responsible for handling navigation within the application.
 *
 * This router is configured with a history mode using `createWebHistory`,
 * allowing clean URLs without hash (#) symbols, and is initialized with
 * the application's route definitions.
 *
 * The `routes` parameter contains the route configuration array, where each
 * route object defines the mapping between a URL path and its corresponding
 * component or functionality.
 *
 * This instance is used to navigate programmatically or to define navigation
 * guards and resolve routes.
 */
const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Change the document title and meta description after each route change
router.afterEach((to) => {
    const defaultTitle = 'LinkCurt | Acortador de URLs';
    document.title = to.meta.title || defaultTitle;

    const metaDescription = document.querySelector('meta[name="description"]');
    const defaultDescription = 'Acorta, gestiona y analiza tus enlaces con LinkCurt, una herramienta gratuita y de código abierto.';
    if (metaDescription) {
        metaDescription.setAttribute('content', to.meta.description || defaultDescription);
    }
});

export default router;
